import axios from 'axios'
import Global from '../Global'
import {sessionHeader } from './main.api'

export default class FolderApi {
    constructor(){}

    static getRootfolder(skip, number = 20){
        let data = {
            "skip": skip,                                         //(optional) number of documents to skip, default 0
            "number": number,                                     //(optional) number of documents to return, default 20
        }
        return axios
        .post(Global.GetAPIURL() + '/folder/root', JSON.stringify(data), sessionHeader).catch(function(err) {
           if(typeof err.response != "undefined" && err.response.status == 401){
                Global.logout()
                sessionStorage.setItem("invalid_session_id", true)
            }
        })
    }

    static getRootfolderAllowedForChannelCreate(skip, number = 20){
        let data = {
            "skip": skip,                                         //(optional) number of documents to skip, default 0
            "number": number,
            "allowed_for_channel_create": true

        }
        return axios
        .post(Global.GetAPIURL() + '/folder/root', JSON.stringify(data), sessionHeader).catch(function(err) {
           if(typeof err.response != "undefined" && err.response.status == 401){
                Global.logout()
                sessionStorage.setItem("invalid_session_id", true)
            }
        })
    }
    static listContent(channel_id, skip, number = 1000, with_parent_docs = false){
        let data = {
            "folder_id": channel_id,
            "skip": skip,                                         //(optional) number of documents to skip, default 0
            "number": number,                                     //(optional) number of documents to return, default 20
            // "sort_modified": false                            //(optional) do sorting by modified timestamp
            // "sort_size": false                                //(optional) do sorting by size
            // "sort_invert": false                              //(optional) change the sorting direction
        }
        if(with_parent_docs){
            data.with_parent_docs = true
        }
        return axios
        .post(Global.GetAPIURL() + '/folder/ls', JSON.stringify(data), sessionHeader).catch(function(err) {
           if(typeof err.response != "undefined" && err.response.status == 401){
                Global.logout()
                sessionStorage.setItem("invalid_session_id", true)
            }
        })
    }

    static listAdminContent(channel_id, skip, number = 20){
        let data = {
            "folder_id": channel_id,
            "skip": skip,                                         //(optional) number of documents to skip, default 0
            "number": number,
            "admin": true
            // "sort_modified": false                            //(optional) do sorting by modified timestamp
            // "sort_size": false                                //(optional) do sorting by size
            // "sort_invert": false                              //(optional) change the sorting direction
        }
        return axios
        .post(Global.GetAPIURL() + '/folder/ls', JSON.stringify(data), sessionHeader).catch(function(err) {
           if(typeof err.response != "undefined" && err.response.status == 401){
                Global.logout()
                sessionStorage.setItem("invalid_session_id", true)
            }
        })
    }


    static createSubFolder(channel_id, folder_name){
        let data = {
            "parent_id": channel_id,
            "folder_name": folder_name,
        }
        return axios
        .post(Global.GetAPIURL() + '/folder/create', JSON.stringify(data), sessionHeader).catch(function(err) {
           if(typeof err.response != "undefined" && err.response.status == 401){
                Global.logout()
                sessionStorage.setItem("invalid_session_id", true)
            }
        })
    }

    static createRootFolder(node_id, folder_name){
        let data = {
            "node_id": node_id,
            "folder_name": folder_name,
        }
        return axios
        .post(Global.GetAPIURL() + '/folder/create', JSON.stringify(data), sessionHeader).catch(function(err) {
           if(typeof err.response != "undefined" && err.response.status == 401){
                Global.logout()
                sessionStorage.setItem("invalid_session_id", true)
            }
        })
    }

    static deleteFF(ff_id, parent_id = ''){
        let data = {
            "ff_id": ff_id,
            "parent_id": parent_id,
        }
        return axios
        .post(Global.GetAPIURL() + '/folder/delete', JSON.stringify(data), sessionHeader).catch(function(err) {
           if(typeof err.response != "undefined" && err.response.status == 401){
                Global.logout()
                sessionStorage.setItem("invalid_session_id", true)
            }
        })
    }

    static renameFF(ff_id, ff_name, parent_id = '', is_file){

        if(parent_id == 'root'){
            parent_id = ""
        }
        let data = {
            "ff_id": ff_id,
            "ff_name": ff_name,
            "parent_id": parent_id,
            "is_file": false,
        }
        if(is_file == "file"){
             data = {
                "ff_id": ff_id,
                "ff_name": ff_name,
                "parent_id": parent_id,
                "is_file": true,
            }
        }
        if(ff_id == parent_id){
             data = {
                "ff_id": ff_id,
                "ff_name": ff_name,
                "parent_id": '',
                "is_file": false,
            }
        }

        return axios
        .post(Global.GetAPIURL() + '/folder/rename', JSON.stringify(data), sessionHeader).catch(function(err) {
           if(typeof err.response != "undefined" && err.response.status == 401){
                Global.logout()
                sessionStorage.setItem("invalid_session_id", true)
            }
        })
    }

    static Details(folder_id){
        let data = {
            "folder_id": folder_id
        }
        return axios
        .post(Global.GetAPIURL() + '/folder/details', JSON.stringify(data), sessionHeader).catch(function(err) {
           if(typeof err.response != "undefined" && err.response.status == 401){
                Global.logout()
                sessionStorage.setItem("invalid_session_id", true)
            }
        })
    }
}
